import { v4 } from "uuid";

export type MoneticCommonParams = {
    userId: number;
    franchiseId: string;
    operatorId: string;
    uuidUser: string | null;
    designation: string;
    mark: string;
    remarque: string;
};

export type MoneticFullParams = MoneticCommonParams & {
    reference: string;
    merchantCode: string;
    deviceCode: string;
    port: any;
    url: string;
    kiss: boolean;
    speed: string | number;
    typeConfig: any;
    typeTerminal: any;
    ipAddress: string;
    paymentType: string;
    paymentMethod: any;
    timeout: string;
    webhook: string;
    selectedIdAdyen: { label: string; value: string };
    mode: string;
    idIntegrator: string;
    autoValidate: any;
    currency: string;
    adyenConfig: any;
    isAutoFill: boolean;
    keyValue: string;
    serialNumber: any;
    communication: string;
};

/**
 * Builds the payload for adding an MS Solution Tunisie monetic.
 */
export function buildMsSolutionAddPayload(
    params: MoneticCommonParams,
    shopId: string
): any {
    return {
        userId: params.userId,
        shopId,
        franchiseId: params.franchiseId,
        operatorId: params.operatorId,
        uuidUser: params.uuidUser,
        data: [
            {
                id: v4(),
                designation: params.designation?.trim(),
                mark: params.mark,
                note: params.remarque,
                shopId,
                isArchived: false,
            },
        ],
    };
}

/**
 * Builds the payload for adding a standard monetic (non-MS Solution).
 */
export function buildMoneticAddPayload(
    params: MoneticFullParams,
    shopId: string,
    isCurrencyExist: string
): any {
    return {
        userId: params.userId,
        shopId,
        franchiseId: params.franchiseId,
        operatorId: params.operatorId,
        uuidUser: params.uuidUser,
        data: [
            {
                id: v4(),
                designation: params.designation?.trim(),
                mark: params.mark,
                reference: params.reference,
                note: params.remarque,
                shopId,
                merchant_code: params.merchantCode,
                device_code: params.deviceCode,
                port: params.port,
                url: params.url,
                kiss: params.kiss,
                speed: params.speed,
                setup_type: params.typeConfig,
                terminal_type: params.typeTerminal,
                ip: params.ipAddress,
                payment_type: params.paymentType,
                payment_method: params.paymentMethod,
                timeout: params.timeout,
                isArchived: false,
                webhook: params.webhook,
                adyenIp: params.selectedIdAdyen.value.trim(),
                mode: params.mode,
                idIntegrator: params.idIntegrator,
                autoValidate: params.autoValidate,
                currency: params.currency,
                adyenConfig:
                    params.mark === "Adyen"
                        ? {
                              ...params.adyenConfig,
                              currency: isCurrencyExist,
                              isAutoFill: params.isAutoFill,
                          }
                        : params.adyenConfig,
                key: params.keyValue,
                serialNumber: params.serialNumber,
                communication: params.communication,
            },
        ],
    };
}

/**
 * Builds the payload for editing an MS Solution Tunisie monetic.
 */
export function buildMsSolutionEditPayload(
    params: MoneticCommonParams & {
        shopId: string | number;
        peripheralId: string;
    }
): any {
    return {
        userId: params.userId,
        shopId: params.shopId,
        franchiseId: params.franchiseId,
        operatorId: params.operatorId,
        uuidUser: params.uuidUser,
        peripheralType: "monetics",
        data: [
            {
                id: params.peripheralId,
                designation: params.designation?.trim(),
                mark: params.mark,
                note: params.remarque,
                shopId: params.shopId,
            },
        ],
    };
}

/**
 * Builds the payload for editing a standard monetic (non-MS Solution).
 */
export function buildMoneticEditPayload(
    params: MoneticFullParams & {
        shopId: string | number;
        peripheralId: string;
        nomTpe: string;
    }
): any {
    return {
        userId: params.userId,
        shopId: params.shopId,
        franchiseId: params.franchiseId,
        operatorId: params.operatorId,
        uuidUser: params.uuidUser,
        peripheralType: "monetics",
        data: [
            {
                id: params.peripheralId,
                designation: params.designation?.trim(),
                tpe_name: params.nomTpe,
                reference: params.reference,
                note: params.remarque,
                android: "android",
                merchant_code: params.merchantCode,
                speed: String(params.speed),
                device_code: params.deviceCode,
                port: params.port,
                url: params.url,
                shopId: params.shopId,
                ip: params.ipAddress,
                payment_type: params.paymentType,
                mark: params.mark,
                payment_method: params.paymentMethod,
                timeout: params.timeout,
                kiss: params.kiss,
                setup_type: params.typeConfig,
                terminal_type: params.typeTerminal,
                isArchived: false,
                webhook: params.webhook,
                adyenIp: params.selectedIdAdyen.value.trim(),
                mode: params.mode,
                idIntegrator: params.idIntegrator,
                autoValidate: params.autoValidate,
                currency: params.currency,
                adyenConfig: {
                    ...params.adyenConfig,
                    isAutoFill: params.isAutoFill,
                },
                key: params.keyValue,
                serialNumber: params.serialNumber,
                communication: params.communication,
            },
        ],
    };
}
